import { render, staticRenderFns } from "./StoriesCard.vue?vue&type=template&id=176a6906&scoped=true&"
import script from "./StoriesCard.vue?vue&type=script&lang=js&"
export * from "./StoriesCard.vue?vue&type=script&lang=js&"
import style0 from "./StoriesCard.vue?vue&type=style&index=0&id=176a6906&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "176a6906",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/home/regalstreak/development/web/souvenirsofconflict/souvenirsofconflict/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib'
import { VCardText } from 'vuetify/lib'
import { VDialog } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VImg } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
installComponents(component, {VCard,VCardText,VDialog,VFlex,VIcon,VImg,VLayout})
